import { makeAsync } from '@citrite/workspace-ui-platform-react';

export const Error404 = makeAsync(() => import('./404').then(m => m.Error404));
